<template>
  <v-container v-if="personal">
    <v-row>
      <v-col lg="5" offset-lg="4">
        <v-card class="card" color="primary">
          <v-card-title class="font-weight-bold justify-center">Resultados C3</v-card-title>
          <v-card-text>
            <v-container>
              <v-row dense>
                <v-col cols="12" align="center">
                  <div class="text-subtitle-1 font-weight-bold">
                    Vigencia de evaluaciones de C3 <span class="red--text">*</span>
                  </div>
                  <v-date-picker
                    v-model="fechaElegida"
                    locale="es"
                    color="secondary"
                    no-title
                    full-width
                    :rules="required"
                  ></v-date-picker>
                </v-col>
                <v-col cols="12" class="pa-0 my-0">
                  <v-select
                    v-model="resultadoElegido"
                    dense
                    filled
                    rounded
                    color="secondary"
                    background-color="primary"
                    :items="resultados"
                    item-value="title"
                    item-text="title"
                    item-color="secondary"
                    :rules="required"
                  >
                    <template v-slot:label>Resultado <span class="red--text">*</span> </template>
                  </v-select>
                </v-col>
                <v-col cols="12" align="center" class="pa-0 my-0">
                  <v-textarea
                    no-resize
                    rows="3"
                    color="secondary"
                    background-color="primary"
                    label="Observaciones (Opcional)"
                    rounded
                    filled
                    dense
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn text class="error--text mb-4 mx-8" v-on:click="$router.go(-1)">Cancelar</v-btn>
            <v-btn
              color="secondary"
              class="primary--text mb-4 mx-8"
              :loading="loading"
              :disabled="!resultadoElegido || !fechaElegida || loading"
              v-on:click="triggerAsignacionTurno()"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import { NotificationFactory, NOTIFICATION_TYPES } from '@src/modules/notificaciones/domain/NotificationFactory'
import Notificacion from '@src/modules/notificaciones/domain/Notificacion'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_PERSONAL_FOTO_CUIP(this.id)
  },

  data() {
    return {
      loading: false,
      fechaElegida: null,
      resultadoElegido: null,

      resultados: [
        { id: 1, title: 'Aprobado' },
        { id: 2, title: 'No aprobado' },
        { id: 3, title: 'No cubre perfil' },
        { id: 3, title: 'Sí cubre perfil' },
      ],

      required: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalFotoCuip',
    }),
  },

  methods: {
    ...mapActions('resultadosPersonalesC3', ['createResultado']),
    ...mapActions('personal', ['updatePersonal', 'updatePuestoPersonal', 'fetchPersonal']),
    ...mapMutations('personal', ['SET_PERSONAL_FOTO_CUIP']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('notificaciones', ['createNotification']),

    async triggerAsignacionTurno() {
      this.loading = true
      const resultado = {
        resultado: this.resultadoElegido,
        fechaVigenciaEvaluacionC3: this.fechaElegida,
        observaciones: this.personal.observacionesC3 || '',
      }

      await this.createResultado({
        idPersonal: this.id,
        resultado,
      })
      await this.sendNotification()

      this.loading = false
      this.$router.push('/enlace_c3/personal')
    },

    async sendNotification() {
      try {
        const notification = new NotificationFactory(Notificacion).createNotification(
          NOTIFICATION_TYPES.EMISION_RESULTADO_C3,
          {
            responsable: Number(localStorage.getItem('idPersonal')),
            afectado: this.id,
            nombrePersonal: this.getFullName(this.personal),
            resultado: this.resultadoElegido,
            fechaVigencia: moment(this.fechaElegida).format('DD/MM/YYYY'),
          }
        )

        await this.createNotification(notification)
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al notificar emisión de resultados.')
      }
    },
  },
}
</script>
